// extracted by mini-css-extract-plugin
export default {"price":"PriceInput_price__s6Lgo","inputPrice":"PriceInput_inputPrice__JlzuJ","span":"PriceInput_span__urvuf","spanContainer":"PriceInput_spanContainer__jJTCD"};